import api from '../factory/AxiosInstance'
import { AppSettings } from '../config/index'

const SMS_ACTIVATION_API_URL = 'SMS_ACTIVATION_API_URL';
const SMS_ACTIVATION_KEY = 'SMS_ACTIVATION_KEY';

const serializeToQueryParameters = (body) => {
  const parameters = [];
  for (const propName in body)
    if (body.hasOwnProperty(propName) && body[propName]) {
      parameters.push(encodeURIComponent(propName) + '=' + encodeURIComponent(body[propName]));
    }
  return parameters.join('&');
}

export const activateSMS = async (body) => {
  const authorization = await AppSettings.get(SMS_ACTIVATION_KEY);
  const fullUrl = `${await AppSettings.get(SMS_ACTIVATION_API_URL)}/api/SmsBot?${serializeToQueryParameters(body)}`;
  return await api.post(fullUrl, null, {
    headers:
    {
      'Authorization': authorization
    }
  });
}